import styled from "styled-components";

export const StyledWrapper = styled.a`
  color: ${({ theme }) => theme.colors.neutralsTextLight};
  ${({ theme }) => theme.fontStyles.InterfaceCopySmall}
  display: inline-flex;
  align-items: center;
  gap: 4px;

  > span {
    color: ${({ theme }) => theme.colors.neutralsTextLight};
  }
`;
